module.exports = __webpack_public_path__ + "img/zhewan5.15e02b10.jpg";